<template>
    <span :class="{'icon-large': large, 'icon-small': small}"><i class="fa fa-spin" :class="icon"></i><slot
            v-if="!!$slots.default"></slot></span>
</template>

<style lang="scss" scoped>
    i.icon-small {
        font-size: 12px;
    }

    .icon-large {
        font-size: 2em;
    }
</style>


<script>
    export default {
        props: {
            icon: {default: 'fa-star'},
            size: {default: ''},
        },

        computed: {
            small() {
                return ['sm', 'small'].includes(this.size);
            },
            normal() {
                return ['', 'normal'].includes(this.size);
            },
            large() {
                return ['lg', 'large'].includes(this.size);
            },
        }
    };
</script>
